import { useEffect } from 'react';
import Banner from 'app/components/Banner/Banner';
import LayoutContainer from 'app/containers/LayoutContainer';
import { Container, Typography, Box, Button } from '@mui/material';
import { trackVisitOnlineStationHomePage } from 'mixpanel';

export function HomePage() {
  useEffect(() => {
    trackVisitOnlineStationHomePage();
  }, []);

  const ONLINE_STATION_URL = 'https://www.online-station.net/';

  return (
    <>
      <LayoutContainer pageTitle={'Home'}>
        <>
          <Banner />
          <Box pt="2rem" pb="2rem">
            <Container>
              <Box display="flex" flexDirection="column" alignItems="center" minHeight="40vh" sx={{ gap: '0.25rem' }}>
                <Typography variant="h6">FOR ALL LATEST NEWS,</Typography>
                <Typography variant="h6">PLEASE VISIT</Typography>
                <Button
                  data-testid="btn_banner-link"
                  sx={{ lineHeight: '1rem', textAlign: 'end' }}
                  href={ONLINE_STATION_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography variant="h6" fontWeight="bold">
                    ONLINE &nbsp; STATION &nbsp; WEBSITE
                  </Typography>
                </Button>
              </Box>
            </Container>
          </Box>
        </>
      </LayoutContainer>
    </>
  );
}
